import CoreQuickSearch, {
    QuickSearchClassList,
    QuickSearchElements,
    QuickSearchSelectors,
    QuickSearchTexts,
} from 'ui-core/widgets/quick-search/js/quick-search';

import {ComponentInjector, ComponentSelector} from '@atypon/ui-utils';

class Texts extends QuickSearchTexts {
}

class ClassList extends QuickSearchClassList {
}

class Selectors extends QuickSearchSelectors {
    qsCheckboxInputs = new ComponentSelector('.quick-search__checkbox-container input');
}

class Elements extends QuickSearchElements {
    qsCheckboxInputs: Array<HTMLInputElement> = [];
}

interface QuickSearch {
    get elements(): Elements;

    get texts(): Texts;

    get classList(): ClassList;

    get selectors(): Selectors;
}

@ComponentInjector(Selectors, Elements, ClassList, Texts)
class QuickSearch extends CoreQuickSearch {
    addEventListeners(): void {
        super.addEventListeners();
        this.elements.qsCheckboxInputs.forEach(currentInput => {
                currentInput.addEventListener('change', () => {
                    let isChecked = currentInput.checked;
                    this.elements.qsCheckboxInputs.forEach(input => input.checked = false);
                    currentInput.checked = isChecked;
                });
            }
        )
    }
}

export default QuickSearch;

export {
    Selectors as QuickSearchSelectors,
    Elements as QuickSearchElements,
    ClassList as QuickSearchClassList,
    Texts as QuickSearchTexts,
};
